import type { HostConfiguration } from '@economic/react-app';
import { setupAddonsEndpoint } from '~/app/shared/util/api/addonsApiClient';
import { setupHqEndpoint } from '~/app/shared/util/api/hqApiClient';
import { setupMarketEndpoint } from '~/app/shared/util/api/marketApiClient';
import { setupWorkflowsEndpoint } from '~/app/shared/util/api/workflowsApiClient';
import { setupAppSettingsGwApiClientEndpoint } from '~/app/shared/util/api/appSettingsGwApiClient';

/**
 * Some api clients require host configuration to be loaded first. This method configures those endpoints based on the config.
 */
export function setupHostEndpoints(services: HostConfiguration['services']): void {
    setupAddonsEndpoint(services.addons);
    setupMarketEndpoint(services.market);
    setupWorkflowsEndpoint(services.workflows);
    setupHqEndpoint(services.hq);
    setupAppSettingsGwApiClientEndpoint(services.appSettings);
}
